import React, { useEffect, useCallback, useState } from 'react';
import axios from '../../../shared/axios/axiosProxy';
import i18n from '../../../utils/i18n.js';
import StyledButton from '../../../shared/components/styledButton/styledButton.jsx';
import ACTIONS from '../../../redux/action.js';
import { useSelector, useDispatch } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { navigateToUrl, createCalComUrl } from '../../utils/companyUtils.js';
import './payment.scss';

const CheckoutReturn = () => {
    const companyStore = useSelector((state) => state.company_store);
    const dispatch = useDispatch();

    const [sessionResponse, setSessionResponse] = useState(null);
    const [fullCalComURL, setFullCalComURL] = useState(null);

    useEffect(() => {
        getStripeSession();
    }, []);

    useEffect(() => {
        setFullCalComURL(createCalComUrl({ reqId: companyStore.reqID, compCtcName: companyStore.companyctcname, compEmail: companyStore.email, compPhone: companyStore.companyPhone }));
    }, [companyStore.reqID, companyStore.companyctcname, companyStore.email, companyStore.companyPhone]);

    const dataLayerUpdate = () => {
        if (companyStore.leadtype === 'REG') {
            window.dataLayer.push({
                event: 'sf_step_reg_checkout_completed',
                event_category: 'regflow',
            });
        } else if (companyStore.leadtype === 'VAF') {
            window.dataLayer.push({
                event: 'sf_step_vaf_checkout_completed',
                event_category: 'vafflow',
            });
        }
    };

    useEffect(() => {
        sessionResponse && sessionResponse.status === 'complete' && companyStore.leadtype && dataLayerUpdate();
    }, [sessionResponse, companyStore.leadtype]);

    useEffect(() => {
        fullCalComURL && setTimeout(() => {
            navigateToUrl(fullCalComURL);
        }, 5000);
    }, [fullCalComURL]);


    const getStripeSession = async () => {
        const sessionId = companyStore.stripeSessionId;

        // Get checkout session details
        await axios
            .get(`/api/checkout/session/${sessionId}`)
            .then((response) => {
                if (response.data.status === 'open') {
                    dispatch(
                        ACTIONS.addCompanyInfo({
                            id: 'checkoutComplete',
                            data: false,
                            stateObject: 'company_store',
                        })
                    );
                }
                setSessionResponse(response.data);
            })
            .catch((error) => {
                console.log('AXIOS ERROR: ', error.response?.data || error.message);
            });
    };

    return (
        <div className='payment-complete-container'>
            {sessionResponse && fullCalComURL && sessionResponse.status === 'complete' && (
                <>
                    <p className='payment-regular-text'>{i18n.t('searchflow.paymentCompleteText')}</p>
                    <StyledButton
                        color='NewReqBtn'
                        onClick={() => {
                            navigateToUrl(fullCalComURL);
                        }}
                    >
                        {i18n.t('general.bookingappointment')}
                    </StyledButton>
                </>
            )}
        </div>
    )
}

export default withTranslation()(CheckoutReturn);